// extracted by mini-css-extract-plugin
module.exports = {"Stage":"frontend-components-chat_rooms-styles-Stage__Stage--3ctfj"};